import { Link, Head } from "@inertiajs/react";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";

import usePage from "@/hooks/usePage";
import { TextField } from "@/components/TextField/TextField";
import { SessionFormsLayout } from "@/layouts/SessionForms";

type Inputs = {
  "user[email]": string;
};

export default function NewSession() {
  const { props } = usePage();
  const { register } = useForm<Inputs>();

  return (
    <>
      <Head>
        <title>Sign Up</title>
        <meta name="description" content="Sign Up for a Blpnt account" />
      </Head>
      <form
        className="w-full flex flex-col gap-2"
        action="/users"
        method="POST"
      >
        <input
          type="hidden"
          name="authenticity_token"
          value={props.csrf_token}
        />
        <h1 className="text-center text-3xl font-medium relative after:content-[''] after:block after:w-px after:h-[42px] after:mt-4 after:mx-auto after:bg-gray-300">
          Sign Up
        </h1>
        <TextField
          label="Email"
          placeholder="email@example.com"
          {...register("user[email]", { required: true })}
        />
        <Button type="submit">Sign Up</Button>
      </form>
      <p className="mt-4 text-sm text-gray-500">
        Already have an account?{" "}
        <Link href="/users/sign_in" className="text-primary">
          Sign In.
        </Link>
      </p>
    </>
  );
}

NewSession.layout = (page: React.ReactNode) => (
  <SessionFormsLayout children={page} />
);
